import { useNavigate } from "react-router-dom";
import React from "react";
import "./Home.css";
import { SupplierCenteralHeader } from "../Header";
import { SupplierCenteralFooter } from "../Footer";

export { SupplierCenteralHome };

function SupplierCenteralHome() {

  return (
    <div>
      {/* HEADER SEC */}
      <SupplierCenteralHeader />
      {/* HEADER SEC */}

      {/* BANNER SEC */}
      <search className="banner-sec">
        <div className="banner-body">
          <img src="/images/supplier-c-banner.jpg" alt="" />
        </div>
      </search>
      {/* BANNER SEC */}

      {/* WIN TOGETHER SEC */}
      <section className="octa-service-sec position-relative">
        <div className="octa-service-body position-relative">
          <h2>Win together with Octa</h2>
          <p>At Octas, we are passionate about finding and building trusted partnerships with suppliers who can deliver quality and value to our customers.</p>
          <div className="octa-service-list d-grid position-relative">
            <div className="octa-service-border">
              <div className="octa-service-box d-flex position-relative">
                <div className="s-box-cnt d-flex flex-column">
                  <h3>Why be a Octas supplier?</h3>
                  <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
                  <a href="#" className="d-flex align-center justify-center position-relative">Learn More</a>
                </div>
                <div className="s-box-img" style={{ background: 'url(https://img.freepik.com/premium-psd/color-year-frame-mockup_23-2151486173.jpg) center center no-repeat' }}></div>
              </div>
            </div>
            <div className="octa-service-border">
              <div className="octa-service-box d-flex position-relative">
                <div className="s-box-cnt d-flex flex-column">
                  <h3>Why be a Octas supplier?</h3>
                  <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
                  <a href="#" className="d-flex align-center justify-center position-relative">Learn More</a>
                </div>
                <div className="s-box-img" style={{ background: 'url(https://img.freepik.com/premium-psd/color-year-frame-mockup_23-2151486173.jpg) center center no-repeat' }}></div>
              </div>
            </div>
            <div className="octa-service-border">
              <div className="octa-service-box d-flex position-relative">
                <div className="s-box-cnt d-flex flex-column">
                  <h3>Why be a Octas supplier?</h3>
                  <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
                  <a href="#" className="d-flex align-center justify-center position-relative">Learn More</a>
                </div>
                <div className="s-box-img" style={{ background: 'url(https://img.freepik.com/premium-psd/color-year-frame-mockup_23-2151486173.jpg) center center no-repeat' }}></div>
              </div>
            </div>
            <div className="octa-service-border">
              <div className="octa-service-box d-flex position-relative">
                <div className="s-box-cnt d-flex flex-column">
                  <h3>Why be a Octas supplier?</h3>
                  <p>Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium</p>
                  <a href="#" className="d-flex align-center justify-center position-relative">Learn More</a>
                </div>
                <div className="s-box-img" style={{ background: 'url(https://img.freepik.com/premium-psd/color-year-frame-mockup_23-2151486173.jpg) center center no-repeat' }}></div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* WIN TOGETHER SEC */}

      {/* TRUSTED BY SEC */}
      <section className="trusted-by-sec">
        <div className="trusted-by-body">
          <h2>Trusted By</h2>
          <div className="trusted-by-list d-grid">
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-1.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-2.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-3.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-4.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-5.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-5.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-5.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-5.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-5.png) center center no-repeat' }}></div>
            </div>
            <div className="trusted-by-box">
              <div className="trusted-by-logo" style={{ background: 'url(/images/trusted-by-logos/logo-5.png) center center no-repeat' }}></div>
            </div>
          </div>
        </div>
      </section>
      {/* TRUSTED BY SEC */}

      {/* RESCALE SUPPLIER SEC */}
      <section className="rescale-supplier-sec">
        <div className="rescale-supplier-body d-flex align-center">
          <div className="rescale-supplier-box">
            <div className="rescale-supplier-img" style={{ background: 'url(/images/rescale-s-img.jpg) center center no-repeat' }}></div>
          </div>
          <div className="rescale-supplier-box">
            <h2>Goods not for resale suppliers</h2>
            <p>Octas engages with a diverse range of goods not for resale (GNFR) suppliers to help us build, operate, maintain and digitise our retail stores, distribution and fulfillment centres, production sites and store support centres; transport and market our products; and support our team members, customers and communities. </p>
            <p>In our GNFR supplier central site, we want to provide our current and future suppliers with information on how they need to do business with Coles, access support and celebrate our joint successes.</p>
          </div>
        </div>
      </section>
      {/* RESCALE SUPPLIER SEC */}

      {/* LATEST NEWS SEC */}
      <section className="latest-news-sec">
        <div className="latest-news-body">
          <h2><span>Recent Blog</span> News insignt</h2>
          <div className="latest-news-list position-relative d-flex">
            <div className="latest-news-box">
              <div className="latest-news-img d-flex align-center justify-center">
                <img src="/images/latest-blog-img-1.jpg" alt="" />
              </div>
              <div className="latest-news-cnt">
                <h4 className="d-flex">Latest News  <span>December 29, 2022</span></h4>
                <h3>Gain Real Instagram Followers - 15 Proven Tips to Increase...</h3>
                <a href="#" className="blog-btn d-flex ">Read More <span className="material-symbols-outlined">arrow_right_alt</span></a>
              </div>
            </div>
            <div className="latest-news-box">
              <div className="latest-news-img d-flex align-center justify-center">
                <img src="/images/latest-blog-img-2.jpg" alt="" />
              </div>
              <div className="latest-news-cnt">
                <h4 className="d-flex">Latest News  <span>December 29, 2022</span></h4>
                <h3>Gain Real Instagram Followers - 15 Proven Tips to Increase...</h3>
                <a href="#" className="blog-btn d-flex ">Read More <span className="material-symbols-outlined">arrow_right_alt</span></a>
              </div>
            </div>
            <div className="latest-news-box">
              <div className="latest-news-img d-flex align-center justify-center">
                <img src="/images/latest-blog-img-3.jpg" alt="" />
              </div>
              <div className="latest-news-cnt">
                <h4 className="d-flex">Latest News  <span>December 29, 2022</span></h4>
                <h3>Gain Real Instagram Followers - 15 Proven Tips to Increase...</h3>
                <a href="#" className="blog-btn d-flex ">Read More <span className="material-symbols-outlined">arrow_right_alt</span></a>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* LATEST NEWS SEC */}

      <SupplierCenteralFooter />
    </div>
  );
}